import * as React from 'react';
import GoogleMapReact from 'google-map-react';
import RoomIcon from '@mui/icons-material/Room';
import { Typography, Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AnyReactComponentProps {
    lat: number;
    lng: number;
    text: string;
}

// Fixed: Properly destructure the props object
const AnyReactComponent = ({ lat, lng, text }: AnyReactComponentProps) => (
    <div style={{
        width: 200,
        height: "100%",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        transform: 'translate(-50%, -100%)', // Center the marker
    }}>
        <Typography
            sx={{
                color: "red",
                fontSize: "16px",
                backgroundColor: 'white',
                padding: '4px 8px',
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                whiteSpace: 'nowrap',
                marginBottom: '4px'
            }}>
            {text}
        </Typography>
        <RoomIcon sx={{ color: "red", fontSize: '32px' }} />
    </div>
);

type Props = {
    lat: number;
    lng: number;
    onClick?: (e: GoogleMapReact.ClickEventValue) => void;
}

const BoxMap = styled(Box)(({ theme }) => ({
    width: "100%",
    height: 800,
    [theme.breakpoints.down('sm')]: {
        width: "100%",
        height: 400
    }
}));

const GoogleMapLocation: React.FC<Props> = ({ lat, lng, onClick }) => {
    const { t } = useTranslation();
    const key_google_map = process.env.REACT_APP_API_KEY_GOOGLE!;

    if (!key_google_map) {
        return (
            <BoxMap>
                <Typography color="error" sx={{ p: 2 }}>
                    Google Maps API key is missing. Please set key in your environment variables.
                </Typography>
            </BoxMap>
        );
    }

    return (
        <BoxMap>
            <GoogleMapReact
                draggable
                bootstrapURLKeys={{ key: key_google_map }}
                center={{ lat, lng }}
                defaultZoom={16}
                yesIWantToUseGoogleMapApiInternals
                onClick={onClick}
                options={{
                    draggableCursor: 'pointer',
                    draggingCursor: 'grabbing',
                }}
            >
                <AnyReactComponent
                    lat={lat}
                    lng={lng}
                    text={t("วิทยาลัยพุทธศาสตร์นานาชาติ")}
                />
            </GoogleMapReact>
        </BoxMap>
    );
};

export default GoogleMapLocation;